import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink,RouterLinkActive } from '@angular/router';
import { FontCommonModule } from '../app-common/modules/font-common.module';
import { NavigationComponent } from '../navigation/navigation.component';
import { FooterComponent } from '../footer/footer.component';
import { SeoService } from '../app-common/services/seo.service';


@Component({
    selector: 'app-home',
    imports: [RouterLink, RouterLinkActive, FontCommonModule, NavigationComponent, FooterComponent],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  constructor(private seoService: SeoService) {}

  ngOnInit(): void {
    this.seoService.updateMetaTags({
      title: 'Octoplus Consulting | Cost Management & Carbon Footprint Solutions',
      description: 'Octoplus helps companies enhance performance through factual cost management and carbon footprint monitoring. Expert consulting, training, and digital tools for sustainable operations.',
      canonical: 'https://www.octoplus-consulting.com/en/home'
    });
  }
}
